import { array, object, schema, string } from "@anna-money/anna-web-lib/serializer";

export class SuburbAutocompleteItem extends schema(
  {
    name: string(),
  },
  "SuburbAutocompleteItem",
) {}

export class SuburbAutocompleteResponseData extends schema(
  {
    suburbs: array(object(SuburbAutocompleteItem)),
  },
  "SuburbAutocompleteResponseData",
) {}
